// extracted by mini-css-extract-plugin
export default {"paneWrapper":"light__paneWrapper___joNi8"};